


































































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import router from "../router";
import InputComponent from "../components/input.vue";
import LoaderComponent from "../components/loader.vue";

const authNamespace = "auth";

@Component({
  components: {
    "app-input": InputComponent,
    "app-loader": LoaderComponent
  }
})
export default class SignInPage extends Vue {
  @Getter("getRecoveryPassword", { namespace: authNamespace })
  public recoveryPassword!: any;

  @Action("setRecoveryPassword", { namespace: authNamespace })
  public setRecoveryPassword: any;

  @Getter("getIsLoading", { namespace: authNamespace })
  public isLoading!: boolean;

  @Action("setIsLoading", { namespace: authNamespace })
  public setIsLoading: any;

  @Getter("getIsSubmitted", { namespace: authNamespace })
  public submitted!: boolean;

  @Action("setIsSubmitted", { namespace: authNamespace })
  public setIsSubmitted: any;

  @Getter("getIsErrorRequest", { namespace: authNamespace })
  public isErrorRequest!: boolean;

  @Action("setIsErrorRequest", { namespace: authNamespace })
  public setIsErrorRequest: any;

  @Getter("getIsErrorLogin", { namespace: authNamespace })
  public isErrorLogin!: boolean;

  @Action("setIsErrorLogin", { namespace: authNamespace })
  public setIsErrorLogin: any;

  @Action("recoveryPassword", { namespace: authNamespace })
  public sendRecoveryPassword: any;

  public submitRecoveryPassword() {
    this.setIsSubmitted(true);
    this.setIsErrorLogin(false);
    this.setIsErrorRequest(false);
    if (this.recoveryPassword.isValid()) {
      this.submitRecoveryPasswordValidated();
    }
  }
  public submitRecoveryPasswordValidated() {
    this.setIsLoading(true);
    this.sendRecoveryPassword(this.recoveryPassword)
      .then((res: any) => {
        this.loginResponseSuccess(res);
      })
      .catch((error: any) => {
        this.loginResponseError(error);
      });
  }
  public loginResponseSuccess(resp: any) {
    this.setIsSubmitted(false);
    this.setIsErrorLogin(false);
    this.setIsErrorRequest(false);
    this.setIsLoading(false);
    if (resp.data.accessType === "contributor") {
      window.location.replace(
        `${process.env.VUE_APP_PLATFORM_URL}?access_token=${resp.data.accessToken}&user_id=${resp.data.userId}`
      );
    } else if (resp.data.accessType === "dpo") {
      window.location.replace(
        `${process.env.VUE_APP_ADMIN_DPO_URL}?access_token=${resp.data.accessToken}&user_id=${resp.data.userId}`
      );
    } else if (resp.data.accessType === "admin") {
      window.location.replace(
        `${process.env.VUE_APP_ADMIN_PLATFORM_URL}?access_token=${resp.data.accessToken}&user_id=${resp.data.userId}`
      );
    }
  }
  public loginResponseError(error: any) {
    if (
      error &&
      error.response &&
      error &&
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      this.setIsErrorLogin(true);
      this.setIsErrorRequest(false);
    } else if (error && error.token) {
      this.loginResponseSuccess(error);
    } else {
      this.setIsErrorLogin(false);
      this.setIsErrorRequest(true);
    }
    this.setIsSubmitted(false);
    this.setIsLoading(false);
  }
  public mounted() {
    this.setRecoveryPassword({
      ...this.recoveryPassword,
      pin: this.$route.query.recoveryCode
    });
  }
}
